import { render, staticRenderFns } from "./ShopModel.vue?vue&type=template&id=5570b404&"
import script from "./ShopModel.vue?vue&type=script&lang=js&"
export * from "./ShopModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports